import Vue from 'vue';

const state = {
	vault: {

	}
};

const getters = {
	'vault/list': (st) => st.vault,
	'vault/get': function (st) {
		return (key) => {
			if (typeof st.vault[key] !== 'undefined') return st.vault[key];
			return undefined;
		};
	}
};

const mutations = {
	'VAULT/SET': function (st, { key, value }) {
		Vue.set(st.vault, key, value);
		return value;
	},
	'CLEAN/VAULT': function (st) {
		Vue.set(st, 'vault', {});
	}
};

const actions = {
	'vault/clean': function ({ commit }) {
		commit('CLEAN/VAULT');
	},
	'vault/set': function ({ commit }, { key, value = '' }) {
		commit('VAULT/SET', { key, value });
		return value;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
